<script setup>
import { getI18n } from '@/plugins/i18n'

const color = defineModel({ type: String, default: null })

const i18n = getI18n()
</script>

<template>
  <q-input v-model="color" :label="i18n.t('common.color')">
    <template #append>
      <q-avatar :style="{ 'background-color': color }">
        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
          <q-color v-model="color" no-header no-footer />
        </q-popup-proxy>
      </q-avatar>
    </template>
  </q-input>
</template>
